export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getMembers () {
      const promise = this.server.memberList()
      return promise
    },
    add (context, payload) {
      const promise = this.server.addMember(payload)
      return promise
    },
    update (context, payload) {
      const promise = this.server.updateMember(payload)
      return promise
    },
    remove (context, payload) {
      const promise = this.server.deleteMember(payload)
      return promise
    },
    getById (context, payload) {
      const promise = this.server.memberById(payload)
      return promise
    }
  }
}
